import { Directive, HostListener } from '@angular/core';

@Directive({ selector: '[appDisableDragDrop]' })
export class DisableDragDropDirective {

  constructor() { }
  @HostListener('dragstart', ['$event'])
  onDragStart(event: DragEvent) {
    event.preventDefault();
  }
 
  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
  }
}
